module.exports = __webpack_public_path__ + "img/instagram.d1340c2.svg";